import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.scss';
import './components/DefinitionPopover/DefinitionPopover.css';
import { CookiesProvider } from 'react-cookie';
import { AuthProvider } from './auth/AuthContext';
import Router from './components/Router/Router';
import { UiProvider } from './context/UiContext';
import { isDev } from './utils/env-utils';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: console.error,
  }),
  defaultOptions: { queries: { staleTime: 1000 } },
});

root.render(
  <React.StrictMode>
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <UiProvider>
              <Router />
            </UiProvider>
            {!!isDev && <ReactQueryDevtools initialIsOpen={false} />}
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </CookiesProvider>
  </React.StrictMode>,
);
